import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { NAV, BRAND, waLink } from "@/lib/site";
import { useGoTo, WhatsIcon } from "./ui";

export const Footer = () => {
  const goTo = useGoTo();
  return (
  <footer className="bg-[#070708] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 border-b border-white/10 pb-12">
        <div className="flex items-center gap-4">
          <LogoMark className="w-14 h-14" />
          <div>
            <p className="font-display text-3xl text-[#F3EEE4]">{BRAND}</p>
            <p className="text-sm text-[#A8A196] mt-1">Shitje dhe përpunim mermeri dhe graniti</p>
          </div>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => goTo(n.id)} data-testid={`footer-link-${n.id}`} className="nav-link text-sm text-[#D9D3C7] hover:text-white">{n.label}</button>
          ))}
          <Link to="/portrete" data-testid="footer-link-portrete" className="nav-link text-sm text-[#E3C88A] hover:text-white">Portrete me lazer</Link>
        </nav>
      </div>
      <p className="font-display font-light text-[18vw] leading-[0.85] text-transparent footer-word select-none mt-10" aria-hidden="true">Mermer</p>
      <div className="flex flex-col sm:flex-row justify-between gap-4 mt-8 text-xs text-[#A8A196]">
        <p>© {new Date().getFullYear()} {BRAND}. Të gjitha të drejtat e rezervuara.</p>
        <p>NIPT [për t'u plotësuar]</p>
      </div>
    </div>
  </footer>
  );
};

export const FloatingWa = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Na shkruani në WhatsApp"
    className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_10px_40px_-10px_rgba(37,211,102,0.7)] transition-transform duration-300 hover:scale-110"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
    <WhatsIcon className="w-7 h-7 relative" />
  </a>
);
